export default __webpack_public_path__ + "static/media/pic11.27a3efb4.jpg";